const formNamesToSwap = [
    'free-trial',
    'free-trial-kseries',
    'watch-demo',
    'talk-expert',
    'request-a-quote',
];

const exportedForUnitTesting = () => ({
    rebuildLinkHref,
    formNamesToSwap,
});

const rebuildLinkHref = (href: string, formNames: string[]): string => {
    const [mainLink, formLink] = href.split('|');
    const wizardPrefix = '-wizard-lightbox';
    formNames.forEach(formName => {
        if (formLink.includes(formName)) {
            // Essentially this finds formName string, deletes everything after, and appends `-wizard-lightbox`
            // unless the formLink is already prefixed with '-wizard-lightbox'
            const pattern = new RegExp(`${formName}(?!${wizardPrefix}).*`);
            const newFormName = `${formName}${wizardPrefix}`;
            href = `${mainLink}|${formLink.replace(pattern, newFormName)}`;
        }
    });

    return href;
};

function swapLightboxFormLinksForWizard() {
    if (document.body.dataset.formWizardSwap === 'enabled') {
        const lightboxLinks: HTMLAnchorElement[] = Array.from(
            document.querySelectorAll('a[href^="#lightbox|"]')
        );
        lightboxLinks.forEach(
            link => (link.href = rebuildLinkHref(link.href, formNamesToSwap))
        );
    }
}

export { swapLightboxFormLinksForWizard, exportedForUnitTesting };
